import { render, staticRenderFns } from "./CompanySelect.vue?vue&type=template&id=56c7d33e"
import script from "./CompanySelect.vue?vue&type=script&lang=js"
export * from "./CompanySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports